/* eslint-disable camelcase */
import { PaymentsTransaction } from '@mindfulchefuk/api-client'
import errorHandler from '@mindfulchefuk/utils/errorHandler'
import { spraypaintErrorMessage } from '@mindfulchefuk/utils/spraypaintUtils'

interface PaymentsTransactionParamsType {
  purchaseId: string
  cardToken?: string
}

export const paymentsTransaction = async ({
  purchaseId,
  cardToken,
}: PaymentsTransactionParamsType): Promise<{
  url: string
  cardPaymentNotRequired: boolean
}> => {
  let transaction

  try {
    transaction = new PaymentsTransaction({
      purchase_id: purchaseId,
      card_token: cardToken,
    })

    const result = await transaction.save()

    if (!result) {
      throw new Error(spraypaintErrorMessage(transaction))
    }
  } catch (error) {
    errorHandler(error)
  }

  const { threeds_redirect_url, status } = transaction

  return {
    url: threeds_redirect_url || null,
    cardPaymentNotRequired: status === 'completed',
  }
}
